module.exports = __webpack_public_path__ + "img/land.1a154aed.png";